module.exports = __webpack_public_path__ + "media/KZ-KUS.f485bf44.ogg";